<div class="mat-dialog-title">
  <div class="header-container">
    <mat-icon aria-hidden="false">edit_note</mat-icon>
    <p>{{ isNewContact() ? 'Cadastro de Contato' : hasAccessToEditCompany() ? 'Edição Contato' : 'Contato' }}</p>
  </div>
</div>

<div dialog-content class="mat-dialog-content">
  <alert id="alert-modal" class="alert-modal"></alert>

  <form class="contact-form" [formGroup]="companyContactForm">
    <div class="contact-form-a">
      <mat-form-field>
        <mat-label>Unidade</mat-label>
        <input [readonly]="!hasAccessToEditCompany()" matInput type="text" placeholder="Unidade" formControlName="unit" (change)="markAsDirty()" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Nome *</mat-label>
        <input [readonly]="!hasAccessToEditCompany()" matInput type="text" placeholder="Nome *" formControlName="name" (change)="markAsDirty()" />
      </mat-form-field>

      <mat-form-field [style.pointer-events]="hasAccessToEditCompany() ? '' : 'none'">
        <mat-label>Cargo *</mat-label>
        <mat-select #selectedJobDescription formControlName="jobDescription">
          <mat-option
            [style.pointer-events]="hasAccessToEditCompany() ? '' : 'none'"
            *ngFor="let jobDescription of getJobDescriptionList()"
            [value]="jobDescription"
            >{{ jobDescription.getTitle() }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ hasMobile() ? 'Telefone' : 'Telefone *' }}</mat-label>
        <input
          [readonly]="!hasAccessToEditCompany()"
          matInput
          type="text"
          [placeholder]="hasMobile() ? 'Telefone' : 'Telefone *'"
          formControlName="telephone"
          [textMask]="{
            mask: telephoneMask,
            guide: false,
            keepCharPositions: true
          }"
          (change)="markAsDirty()" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ hasTelephone() ? 'Celular' : 'Celular *' }}</mat-label>
        <input
          [readonly]="!hasAccessToEditCompany()"
          matInput
          type="text"
          [placeholder]="hasTelephone() ? 'Celular' : 'Celular *'"
          formControlName="mobile"
          [textMask]="{
            mask: mobileMask,
            guide: false,
            keepCharPositions: true
          }"
          (change)="markAsDirty()" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>E-mail *</mat-label>
        <input [readonly]="!hasAccessToEditCompany()" matInput type="text" placeholder="E-mail *" formControlName="email" (change)="markAsDirty()" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Área</mat-label>
        <input [readonly]="!hasAccessToEditCompany()" matInput type="text" placeholder="Área" formControlName="area" (change)="markAsDirty()" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Informações Adicionais</mat-label>
        <input
          [readonly]="!hasAccessToEditCompany()"
          matInput
          type="text"
          placeholder="Informações Adicionais"
          formControlName="additionalInformation"
          (change)="markAsDirty()" />
      </mat-form-field>

      <mat-checkbox
        [style.pointer-events]="hasAccessToEditCompany() ? '' : 'none'"
        #chechbox
        formControlName="hasLegalRepresentativeInfo"
        (change)="markAsDirty()"
        >Responsável Legal</mat-checkbox
      >
    </div>

    <div class="contact-form-b">
      <mat-form-field *ngIf="chechbox.checked">
        <mat-label>RG *</mat-label>
        <input
          [readonly]="!hasAccessToEditCompany()"
          matInput
          type="text"
          placeholder="RG *"
          formControlName="federalRegistration"
          [textMask]="{
            mask: federalRegistrationMask,
            guide: false,
            keepCharPositions: true
          }"
          (change)="markAsDirty()" />
      </mat-form-field>

      <mat-form-field *ngIf="chechbox.checked">
        <mat-label>CPF *</mat-label>
        <input
          [readonly]="!hasAccessToEditCompany()"
          matInput
          type="text"
          placeholder="CPF *"
          formControlName="socialNumber"
          [textMask]="{
            mask: socialNumberMask,
            guide: false,
            keepCharPositions: true
          }"
          (change)="markAsDirty()" />
      </mat-form-field>
    </div>
  </form>
  <p class="footer-informatios">Campos marcados com * são obrigatórios</p>
</div>

<div mat-dialog-actions class="mat-dialog-actions">
  <div class="btn close-btn" (click)="close()">
    <span>Fechar</span>
  </div>

  <div *ngIf="hasAccessToEditCompany()">
    <div *ngIf="isNewContact()" class="btn submit-btn" (click)="onSaveContact()">
      <span>Salvar</span>
    </div>

    <div *ngIf="!isNewContact()" class="btn submit-btn" (click)="onEditContact()">
      <span>Salvar</span>
    </div>
  </div>
</div>
